import { render, staticRenderFns } from "./FixMethodButton.vue?vue&type=template&id=5935efcb&"
import script from "./FixMethodButton.vue?vue&type=script&lang=js&"
export * from "./FixMethodButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports